import { platform } from '../../device/platform'
// import saveModules from '../../versions/saveModules'
import { IDiscoveryResponse } from '../../../interfaces/MFE/IDiscoveryAPI';
import fetchMicrofrontsDiscovery from '../../versions/discovery'
import { filesystem } from '..';
import { MODULES_ENTITY } from '../../versions/ModulesEntity';

// VER CASUISTICA DE LEER MODULOS:
// 1 - tenienndo un initialToken --> leer usuario --> buscar modulos de archivo --> DONE
// 2 - sin initialToken --> buscar cualquier archivo de cualquier usuario
// 3 - sin initialToken de ningun usuario. Primera vez sin conexion.

export default async function initMicrofrontendsDiscovery ( initialToken?: string ): Promise<IDiscoveryResponse> {
  
  return await fetchMicrofrontsDiscovery()
  .then(async (res) => {
    if ( platform !== 'web' ){
        if ( initialToken ){
          // await saveModules(res)
        }
      }
      return res
    })
    .catch( async ( err ) => {

      if ( initialToken && filesystem !== undefined ){
          const modulesSaved = await filesystem.read<IDiscoveryResponse>(filesystem?.getPath('entity', { entity_name: MODULES_ENTITY }))
          if ( modulesSaved !== undefined ) return modulesSaved 
      }

      const defaultResponse = await import('/assets/constants/default-discovery.json')
      return defaultResponse
    
    })
}


